<section class="targeted-department-categories-card" [class.targeted-department-categories-card--embedded]="embedded()">
  <div class="targeted-department-categories-card__header">
    <h2 class="targeted-department-categories-card__title">{{ title() }}</h2>
    @if (description(); as description) {
      <p class="targeted-department-categories-card__description">{{ description }}</p>
    }

    <div class="targeted-department-categories-card__actions">
      <button
        mat-stroked-button
        type="button"
        class="targeted-department-categories-card__action-btn"
        [disabled]="options().length === 0 || all_selected()"
        (click)="selectAll()"
      >
        Seleccionar todas
      </button>
      <button
        mat-stroked-button
        type="button"
        class="targeted-department-categories-card__action-btn"
        [disabled]="options().length === 0 || none_selected()"
        (click)="deselectAll()"
      >
        Deseleccionar todas
      </button>
    </div>
  </div>

  <mat-form-field
    appearance="outline"
    class="targeted-department-categories-card__field"
    [class.mat-form-field-invalid]="!!error_message()"
  >
    <mat-label>Seleccionar</mat-label>
    <mat-select multiple [value]="selection()" (selectionChange)="onSelectionChange($event)">
      @for (option of options(); track option.id) {
        <mat-option [value]="option.id">{{ option.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (error_message(); as message) {
    <p class="targeted-department-categories-card__error" role="alert">{{ message }}</p>
  }
</section>
